import React from 'react'
import Mark from '-!svg-react-loader!../../assets/images/product-mark.svg'
import Close from '-!svg-react-loader!../../assets/images/close.svg'
import Image from '../../components/image'
import Price from '../../components/price'
import { Link } from 'gatsby'

const HomeSliderProduct = ({ prod, position, activeProd, setActiveProd, index}) => {
    const left = position ? position.leftPosition : '0'
    const top = position ? position.topPosition : '0'

    if (!prod && !position) { return null }

    return (
        <div className={`Slide__product${activeProd === index ? ' open' : ''}`} style={{ left: left + '%', top: top + '%' }}>
            <div
                className="Slide__product__mark"
                onClick={() => setActiveProd(activeProd === index ? null : index)}
                onKeyDown={() => setActiveProd(activeProd === index ? null : index)}
                role="presentation"
            >
                <Mark />
            </div>
            {activeProd === index && (
                <div className='Slide__product__popup' >
                    <Link className='Slide__product__title' to={`product/${prod.handle}`}>
                        <Image source={prod.featuredImage} imgClass='Slide__product__image' />
                    </Link>

                    {prod.vendor !== 'vendor-unknown' && (
                        <p className='Slide__product__vendor'>{prod.vendor}</p>
                    )}
                    <Link className='Slide__product__title' to={`product/${prod.handle}`}>{prod.title}</Link>
                    <Price product={prod} />
                    <div
                        className="Slide__product__popup--close"
                        onClick={() => setActiveProd(null)}
                        onKeyDown={() => setActiveProd(null)}
                        role="presentation"
                    >
                        <Close />
                    </div>
                </div>
            )}
        </div>
    )
}

export default HomeSliderProduct
